module.exports = __webpack_public_path__ + "static/media/signatures.2c368151.svg";